import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../../module/legacy/forms/mui-input.directive';
import { InputWrapBodyDirective } from '../../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../../ui/form/input-wrap.component';
import { Product } from '../../product.decorator';
@Component({
    selector: 'product-view-crosssell-products-size',
    templateUrl: '/product-view-crosssell-products-size.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, OptionLabelPipe, TranslationModule, MuiInputDirective, FormsModule, InputWrapComponent, InputWrapBodyDirective]
})
export class ProductViewCrosssellProductsSizeComponent implements OnChanges {
    private _id?: string;
    @Input()
    product?: Product<IProductDataV3>;
    options: Product<IProductDataV3>[] = [];

    constructor(
        private router: Router,
        private app: App
    ) {}
    ngOnChanges(): void {
        this.options = this.getOptions();
        this._id = this.product?.id.toString();
    }
    set id(value: string) {
        this._id = value.toString();
        if (this.id !== this.product?.id.toString()) {
            const selectedProduct = this.options.find(i => i.id.toString() === this.id);
            if (selectedProduct?.data?.url) {
                this.router.navigateByUrl(selectedProduct.data.url);
            }
        }
    }
    get id(): string | undefined {
        return this._id;
    }
    trackByProductId(index: number, product: Product): number {
        return product.id;
    }
    private getOptions(): Product<IProductDataV3>[] {
        if (this.product?.data?.config_size) {
            const crossSellProducts = !this.app.data.showOutOfStock
                ? this.product.sizeCrossSellProducts.filter(i => !i.isOutOfStock)
                : this.product.sizeCrossSellProducts;
            if (crossSellProducts?.length) {
                return [this.product, ...crossSellProducts];
            }
        }
        return [];
    }
}
